<template>
  <b-container>
    <b-row>
      <b-col>
        <b-button variant="blue" @click="reset" to="/admin/accounts">
          <b-icon-building />Return to accounts
        </b-button>
      </b-col>
    </b-row>
    <h5 class="text-center">Sites</h5>
    <b-row>
      <b-col v-if="!showSiteEditor">
        <b-container fluid class="d-flex justify-content-end ml-3">
          <b-row>
            <b-col>
              <b-button @click="onAddSite" variant="blue"
                ><b-icon-plus
              /></b-button>
            </b-col>
          </b-row>
        </b-container>

        <dx-data-grid
          :data-source="sites ? sites : []"
          :columns="sitesGrid.columns"
          :selection="config.selection"
          :onRowDblClick="onSiteSelection"
          :height="350"
        >
        </dx-data-grid>

        <!-- Admins -->
        <b-row class="mb-3">
          <b-col>
            <h4 class="text-center">Administrators</h4>
            <dx-data-grid :data-source="ca" :columns="caGrid.columns" />
          </b-col>
        </b-row>

        <!-- Open Orders -->
        <b-row class="mb-3">
          <b-col>
            <h4 class="text-center">Open Orders</h4>
            <dx-data-grid />
          </b-col>
        </b-row>
      </b-col>
      <b-col v-else>
        <site-editor @onClose="onEditorClose" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SiteEditor from "./SiteEdit";
import { confirm } from "devextreme/ui/dialog";

export default {
  components: {
    SiteEditor
  },
  data() {
    return {
      selectedSite: null,
      showSiteEditor: false,
      sitesGrid: {
        columns: [
          {
            dataField: "name"
          },
          {
            caption: "Open Orders"
          },
          {
            caption: "Devices"
          }
        ]
      },
      caGrid: {
        columns: [
          {
            dataField: "name"
          },
          {
            caption: "Role",
            alignment: "center",
            width: 150,
            calculateDisplayValue(e) {
              return e.is_admin === 1 ? "Administrator" : "";
            }
          }
        ]
      },
      config: {
        selection: {
          mode: "single"
        }
      }
    };
  },
  computed: {
    account() {
      return this.$store.getters["accounts/currentAccount"];
    },
    ca() {
      return this.$store.getters["accounts/caUsers"];
    },
    sites: {
      get() {
        var account = this.$store.getters["accounts/currentAccount"];
        if (!account) {
          return [];
        } else {
          return account.sites ? account.sites : [];
        }
      }
    },
    wasModified: {
      get() {
        return this.$store.getters["accounts/isDirty"];
      },
      set(val) {
        return this.$store.dispatch("accounts/flagChanges", val);
      }
    }
  },
  methods: {
    onSiteSelection(e) {
      debugger;
      var site = e.data ? e.data : null;
      this.$store.dispatch("accounts/currentSite", site).then(() => {
        // this.showSiteEditor = true;

        if (!this.models || !this.items) {
          return this.$store.dispatch("sysEquipment/getModels").then(() => {
            if (
              !this.$store.getters["sysItems/items"] ||
              this.$store.getters["sysItems/items"].length === 0
            ) {
              return this.$store
                .dispatch("sysItems/getItems")
                .then(() => this.$store.dispatch("accounts/getSaUsers"))
                .then(() => (this.showSiteEditor = true));
            } else {
              return this.$store
                .dispatch("accounts/getSaUsers")
                .then(() => (this.showSiteEditor = true));
            }
          });
        } else if (this.models.length === 0 || this.items.length === 0) {
          return this.$store.dispatch("sysEquipment/getModels").then(() => {
            debugger;
            if (
              !this.$store.getters["sysItems/items"] ||
              this.$store.getters["sysItems/items"].length === 0
            ) {
              return this.$store
                .dispatch("sysItems/getItems")
                .then(() => this.$store.dispatch("accounts/getSaUsers"))
                .then(() => (this.showSiteEditor = true));
            } else {
              return this.$store
                .dispatch("accounts/getSaUsers")
                .then(() => (this.showSiteEditor = true));
            }
          });
        }
      });
    },
    onAddSite() {
      var site = {
        account_id: this.account.id,
        name: "",
        address: "",
        city: "",
        state: "",
        postal_code: "",
        orders: [],
        devices: [],
        users: [],
        favorite_Items: [],
        memberships: []
      };

      this.$store.dispatch("accounts/currentSite", site).then(() => {
        this.showSiteEditor = true;
        // this.$router.push({ name: "edit" });
      });
    },
    onEditorClose(e) {
      debugger;
      this.showSiteEditor = e;
    },
    reset() {
      this.showSiteEditor = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/sites.vue